import {environment} from "@environments/environment";
import {Injectable} from "@angular/core";


@Injectable()
export class CssInjectorService {

    constructor() {
    }

    injectCss(cssUrl : string) : void {
        document.getElementsByTagName("head")[0].appendChild(this.getCssTemplate(cssUrl));
    }

    getCssTemplate(cssUrl: string) : HTMLLinkElement {
        var link = document.createElement("link");
        link.href = environment.templateBaseUrl + cssUrl;
        link.type = "text/css";
        link.rel = "stylesheet"
        return link
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/css-injector.service.ts